<template>
  <div :class="classes()">
    <AuthScreen>
      <LoginForm slot="formBox" />
    </AuthScreen>
  </div>
</template>

<script>
import LoginForm from '@/components/Forms/LoginForm';
import AuthScreen from '@/components/AuthScreen';
import { ROUTE_DASHBOARD, ROUTE_LOGIN } from '@/constants/routes';
import { mapFieldsAuth } from '@/store/mapFields';

export default {
  name: 'SignIn',
  props: {},
  components: {
    LoginForm,
    AuthScreen,
  },
  computed: {
    ...mapFieldsAuth(['isAuthenticated']),
  },
  data() {
    return {
      ROUTE_LOGIN,
      ROUTE_DASHBOARD,
      el: 'v-signIn',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
        };
      },
    };
  },
  title() {
    return 'Anmelden';
  },
  created() {
    if (this.isAuthenticated) {
      this.$router.push(ROUTE_DASHBOARD);
    }
  },
};
</script>
